import { apiGet } from './client';
import type { Holding } from '../types/Holding';

// fundId omitted/undefined → all funds (no WHERE clause server-side).
export function getHoldings(fundId?: number): Promise<Holding[]> {
  const qs = fundId == null ? '' : `?fundId=${fundId}`;
  return apiGet<Holding[]>(`/api/holdings${qs}`);
}
